const PREFIX = ['platform', 'integrationToolConfig'];
export function createIntegrationToolConfigRepository(config) {
    const { repository, client } = config;
    function getRetrieveQueryKey(integrationToolId) {
        return [...PREFIX, 'retrieve', integrationToolId];
    }
    return {
        useRetrieve(context, integrationToolId, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: getRetrieveQueryKey(integrationToolId),
                async queryFn() {
                    const response = await client.user.integrationToolConfigRetrieve({
                        integrationToolId,
                    });
                    return response.data;
                },
            });
            return query;
        },
    };
}
//# sourceMappingURL=integrationToolConfigRepository.js.map